import React from 'react';
import ReactDOM from "react-dom/client";
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from "@auth0/auth0-react";
import { getENVData } from './constants/constantValue';
const ENV = getENVData()

if (window.location.hostname === "trip.travelsment.com") {

}



const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <Auth0Provider
      cacheLocation="localstorage"
      domain={ENV.Auth0_domain}
      clientId={ENV.Auth0_ClientId}
      redirectUri={window.location.origin + '/viewer/'}
      audience={ENV.Auth0_Audience}
      useRefreshTokens={true}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
);

reportWebVitals(console.log)



